import { useEffect } from 'react'

const LOADER_FADE_OUT_DURATION_MS = 300

export const useAppLoader = (): void => {
  useEffect(() => {
    const loader = document.getElementById('app-loader')
    if (loader) {
      loader.classList.add('hidden')
      setTimeout(() => loader.remove(), LOADER_FADE_OUT_DURATION_MS)
    }
  }, [])
}
